import { theme } from '../styles/theme';
import React from 'react';

export const styles: Record<string, React.CSSProperties> = {
  sideNav: {
    position: 'fixed',
    left: '24px',
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: 1000,
  },
  navContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '8px',
    gap: '8px',
    backgroundColor: theme.colors.overlay.white95,
    borderRadius: '16px',
  },
  navItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '48px',
    height: '48px',
    borderRadius: '12px',
    textDecoration: 'none',
    transition: 'all 0.15s ease',
  },
  navItemActive: {
    backgroundColor: theme.colors.nav.activeBackground,
    color: theme.colors.nav.activeText,
  },
  navItemInactive: {
    backgroundColor: 'transparent',
    color: theme.colors.text.secondary,
  },
};
